import React, { useEffect, useState } from "react";
import { useStateValue } from "../../StateProvider";
import { getDefaultName, getDefaultValue } from "../../utils";
import { KT_COURSE_PARTICIPATION_CHANGED } from "../../utils/contestParticipationEvents";
import { ContestHttpService } from "../../utils/http/contest_http_service";
import { loadNewestCourse } from "../../utils/Network";
import ModalContestParticipation from "../dialogs/ModalContestParticipation";
import DashboardContestAddTalentModalCta, {
  courseParticipantQuery,
} from "../widgets/DashboardContestAddTalentModalCta";

function NewestCourse({ talent }) {
  const [newest_course, setNewestCourse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alreadyParticipating, setAlreadyParticipating] = useState(false);
  const [courseParticipant, setCourseParticipant] = useState(null);
  const [participantQueryDone, setParticipantQueryDone] = useState(false);
  const [contestParticipationModalIsOpen, setContestParticipationModalIsOpen] =
    useState(0);

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var tr = translations.find((x) => x.key == str);

    if (tr) return getDefaultValue(tr);
    else return "#" + str;
  };

  useEffect(() => {
    if (talent == null) {
      setNewestCourse(null);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setNewestCourse(null);
    loadNewestCourse(talent)
      .then((course) => {
        if (!cancelled) setNewestCourse(course);
      })
      .catch(() => {
        if (!cancelled) setNewestCourse(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [talent]);

  useEffect(() => {
    if (!newest_course?.id) {
      setAlreadyParticipating(false);
      setCourseParticipant(null);
      setParticipantQueryDone(false);
      return undefined;
    }
    let cancelled = false;
    setParticipantQueryDone(false);
    ContestHttpService.loadCourseParticipant(
      courseParticipantQuery(newest_course.id)
    )
      .then((cpData) => {
        if (!cancelled) {
          const cp = cpData?.results?.[0];
          setAlreadyParticipating(!!cp);
          setCourseParticipant(cp ?? null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAlreadyParticipating(false);
          setCourseParticipant(null);
        }
      })
      .finally(() => {
        if (!cancelled) setParticipantQueryDone(true);
      });
    return () => {
      cancelled = true;
    };
  }, [newest_course?.id]);

  useEffect(() => {
    if (!newest_course?.id) return undefined;
    const courseId = newest_course.id;
    const handler = (e) => {
      if (Number(e.detail?.courseId) !== Number(courseId)) return;
      setParticipantQueryDone(false);
      ContestHttpService.loadCourseParticipant(
        courseParticipantQuery(courseId)
      )
        .then((cpData) => {
          const cp = cpData?.results?.[0];
          setAlreadyParticipating(!!cp);
          setCourseParticipant(cp ?? null);
        })
        .catch(() => {
          setAlreadyParticipating(false);
          setCourseParticipant(null);
        })
        .finally(() => setParticipantQueryDone(true));
    };
    window.addEventListener(KT_COURSE_PARTICIPATION_CHANGED, handler);
    return () =>
      window.removeEventListener(KT_COURSE_PARTICIPATION_CHANGED, handler);
  }, [newest_course?.id]);

  return (
    <>
      {loading && (
        <div
          className="w-100 kfont px-0 mb-3 newest-course-contest-cta user-document-contest-cta lan-rtl lan-text-right"
          aria-busy="true"
        >
          <span className="text-muted text-3">
            <i className="fas fa-spinner fa-spin mr-2" aria-hidden="true" />
            {translate("Please wait...")}
          </span>
        </div>
      )}
      {!loading && newest_course && (
        <div className="w-100 kfont px-0 mb-3 newest-course-contest-cta user-document-contest-cta lan-rtl lan-text-right">
          <DashboardContestAddTalentModalCta
            participantQueryDone={participantQueryDone}
            alreadyParticipating={alreadyParticipating}
            translate={translate}
            variant="video"
            courseId={newest_course.id}
            courseTitle={getDefaultName(newest_course.names)}
            courseParticipant={courseParticipant}
          />
        </div>
      )}
      {!loading && !newest_course && talent != null && (
        <div className="w-100 kfont px-0 mb-3 newest-course-contest-cta user-document-contest-cta lan-rtl lan-text-right">
          <button
            type="button"
            className="user-document-caption-item lan-rtl lan-text-right user-document-caption-item--no-contest"
            onClick={() => setContestParticipationModalIsOpen(talent)}
          >
            <i className="fas fa-music" />
            <span>
              {translate("there is no contest available at the moment")}
            </span>
          </button>
        </div>
      )}
      <ModalContestParticipation
        key={"cpm" + contestParticipationModalIsOpen}
        setIsOpen={setContestParticipationModalIsOpen}
        isOpen={contestParticipationModalIsOpen}
        talent={contestParticipationModalIsOpen}
      />
    </>
  );
}

export default NewestCourse;
